/* eslint-disable consistent-return */
import { ReactEditor } from 'slate-react';

export const withParagraphSoftBreak =
  () =>
  <T extends ReactEditor>(editor: T) => {
    const { insertBreak } = editor;

    editor.insertBreak = () => {
      if (editor.selection) {
        editor.insertText('\n');
        return;
      }
      insertBreak();
    };

    return editor;
  };
